import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText } from '@strata/react-buttons';
import PropTypes from 'prop-types';

import {
    ProductPayerConfigBulkUploadErrorMessage,
    ProductPayerConfigBulkUploadErrorsDialog,
} from 'pages/productConfig/ProductPayerConfigBulkUploadErrors';
import {
    generateProductPayerConfigTemplate,
    ValidationErrorsPropType,
} from 'pages/productConfig/ProductPayerConfigBulkUploadSupport';
import { ProductPayerConfigBulkUploadTips } from 'pages/productConfig/ProductPayerConfigBulkUploadTips';
import { ProductPayerConfigFileUpload } from 'pages/productConfig/ProductPayerConfigFileUpload';

export const ProductPayerConfigBulkUploadEmbed = ({
    showValidationErrors = false,
    validationErrors = undefined,
    showValidationErrorDialog = false,
    onCloseErrorDialog = undefined,
    onOpenErrorDialog = undefined,
    onFileChange = undefined,
}) => (
    <div className="margin__top--large">
        <div
            className="margin__bottom--small"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
            <div className="sds_bulk-upload__section-title">Bulk Upload Product Payer Config</div>
            <ActionButtonText
                label="Generate File"
                leftIcon={IconNames.IMPORT}
                onClick={generateProductPayerConfigTemplate}
            />
        </div>
        <div className="sds_bulk-upload__embed-body">
            <div>
                {showValidationErrors && (
                    <ProductPayerConfigBulkUploadErrorsDialog
                        validationErrors={validationErrors}
                        showDialog={showValidationErrorDialog}
                        onCloseDialog={onCloseErrorDialog}
                    />
                )}
                <ProductPayerConfigFileUpload required={false} onFileChange={onFileChange} />
                {showValidationErrors && (
                    <ProductPayerConfigBulkUploadErrorMessage
                        validationErrors={validationErrors}
                        onOpenDialog={onOpenErrorDialog}
                    />
                )}
            </div>
            <div className="flex__gap--small" style={{ flexDirection: 'column' }}>
                <ProductPayerConfigBulkUploadTips />
            </div>
        </div>
    </div>
);

ProductPayerConfigBulkUploadEmbed.propTypes = {
    showValidationErrors: PropTypes.bool,
    validationErrors: ValidationErrorsPropType,
    showValidationErrorDialog: PropTypes.bool,
    onCloseErrorDialog: PropTypes.func,
    onOpenErrorDialog: PropTypes.func,
    onFileChange: PropTypes.func,
};
